export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13621.f41732b1.jpg";